import { Route } from '@angular/router';

import { authGuard } from './core/auth/guards/auth.guard';

export const appRoutes: Route[] = [
  // Public route for supplier reporting (no authentication required)
  {
    path: 'report/:token',
    loadComponent: () => import('./feature/report/pages/report/report.page').then((m) => m.ReportPage),
  },
  // Auth routes (login, forgot password, set password)
  {
    path: 'auth',
    loadChildren: () => import('./core/auth/auth.routes').then((m) => m.authRoutes),
  },
  // Authenticated routes
  {
    path: '',
    loadComponent: () => import('./core/main/main.component').then((m) => m.MainComponent),
    loadChildren: () => import('./core/main/main.routes').then((m) => m.mainRoutes),
    canActivate: [authGuard],
  },
];
